import { Component, OnDestroy } from '@angular/core';
import { Routes } from 'src/app/accountancy/utilities/classes/routes.class';
import { DisbursedService } from './disbursed-service/disbursed.service';
import { Pagination } from '../../utilities/classes/pagination.class';
import { BehaviorSubject, combineLatest, debounceTime, distinctUntilChanged, finalize, map, startWith, Subscription, switchMap, tap } from 'rxjs';
import { WaitHandler } from '../../utilities/classes/wait-handler.class';
import { DisbursedInterface } from '../../utilities/interfaces/disbursed.interface';
import { MatDialog } from '@angular/material/dialog';
import { AccSearchTipComponent } from '../../custom-components/acc-search-tip/acc-search-tip.component';
import { AccTableComponent } from '../../custom-components/acc-table/acc-table.component';
import { Helper } from '../../utilities/classes/helper.class';

@Component({
  selector: 'app-disbursement',
  templateUrl: './disbursement.component.html',
  styleUrls: ['./disbursement.component.scss']
})
export class DisbursementComponent implements OnDestroy {

  public readonly Helper = Helper;
  public readonly routes = Routes;

  public readonly waitHandler = new WaitHandler();
  public readonly pagination = new Pagination();
  public readonly disbList$ = new BehaviorSubject<DisbursedInterface[]>([]);

  private readonly _subsDisbursedList: Subscription = this._getSubsDisbursedList();

  constructor(
    private _disbursedS: DisbursedService,

    private _matDialog: MatDialog,
  ) { }

  public ngOnDestroy(): void {
    this._subsDisbursedList.unsubscribe();
  }

  public readonly dialogs = {
    openSearch: () => this._matDialog.open(AccSearchTipComponent),
    openPrint: async (table: AccTableComponent) => table.printTable(),
  }

  private _getSubsDisbursedList() {
    return combineLatest([
      this.pagination.searchQuery$.pipe(startWith(this.pagination.query), debounceTime(500), distinctUntilChanged()),
      this.pagination.pageLimit$,
      this.pagination.currentPage$,
      this.pagination.reloader$.pipe(startWith(null)),
    ]).pipe(
      tap(() => {
        this.waitHandler.newRequest();
        this.disbList$.next([]);
      }),
      switchMap(([query, limit]) => this._disbursedS.getDisbursedList(this.pagination.start, limit, query).pipe(
        finalize(() => this.waitHandler.finishRequest()),
        map(values => values.body),
        tap(values => {
          this.pagination.setTotalCount(values?.total_rows);
          this.disbList$.next(values?.data ?? []);
        }),
      ))
    ).subscribe();
  }

}
